<div class="headers-row">
  <div class="spacer"></div>
  <div class="headers-row-text">
    <p class="up-is-good-text" *ngIf="metric && metric['up_is_good']">
      Greater than
    </p>
    <p class="up-is-good-text" *ngIf="metric && !metric['up_is_good']">
      Less than
    </p>
    <p class="no-goal-text">No goal</p>
  </div>
</div>
<div class="select-and-inputs-row">
  <school-levels-select
    [schoolLevels]="schoolsData.schoolLevels"
    [selectedSchoolLevel]="schoolsData.selectedSchoolLevel"
    (schoolLevelSelected)="schoolLevelSelected.emit($event)"
    class="school-level-select"
  ></school-levels-select>
  <goal-row-inputs
    [goalValue]="
      goals.filterGoalValue !== undefined
        ? goals.filterGoalValue
        : goals?.updatedData[district?.data.id]?.goal
    "
    [goalInactive]="
      goals.filterGoalInactive !== undefined
        ? goals.filterGoalInactive
        : goals?.updatedData[district?.data.id]?.inactive
    "
    [metric]="metric"
    (goalValueChanged)="filterGoalValueChanged.emit($event.value)"
    (goalInactiveChecked)="filterGoalInactiveChanged.emit($event)"
    class="goal-row-inputs"
  ></goal-row-inputs>
</div>
